import ConsignmentForm from "./ConsignmentForm";

export default ConsignmentForm;
